<div class="flex-column h-100">
  <odx-content-box class="w-100">
    @if (isSingleProductHeaderShown()) {
      <div odxLayout="flex">
        <h6 class="odx-title-6 header-prefix" i18n="@@productConfiguration.attachments.headerPrefix">Zubehör für</h6>
        <app-configuration-wizard-header class="product-header" [data]="headerProducts[0]" [showCosts]="showCosts">
        </app-configuration-wizard-header>
      </div>
    }
    @if (!isSingleProductHeaderShown()) {
      <app-configuration-wizard-header-accordion
        [showCosts]="showCosts"
        [selectedData]="headerProducts"
        [prefix]="headerAccordionPrefix"
        [title]="headerTitle"
      ></app-configuration-wizard-header-accordion>
    }
  </odx-content-box>

  @if (selectedProducts.length) {
    <div class="configuration-wizard-header flex-column space-top">
      <h5
        class="odx-title-5"
        i18n="@@productConfiguration.attachments.header"
        data-testid="productConfiguration.attachments.header"
      >
        Zubehör auswählen
      </h5>
      <app-filter-product (searchEvent)="search($event)"></app-filter-product>
    </div>
    <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
      <div class="attachments" odxLayout="flex">
        @if (filteredReqAttachments$ | async; as reqAttachments) {
          <div [hidden]="reqAttachments.length < 1">
            <h6 class="odx-title-6" i18n="@@productConfiguration.mandatoryAttachments.header">Pflichtzubehör</h6>
            <form [formGroup]="radioButtonForm">
              <odx-radio-group formControlName="selectedAttachment" required="true" class="overflow-hidden h-100">
                <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
                  @for (attachment of reqAttachments; track attachment.id) {
                    <app-attachment-card
                      class="w-100 overflow-hidden"
                      [selectionMode]="selectionMode"
                      [attachmentData]="attachment"
                      [showCosts]="showCosts"
                      [preselectedQuantity]="getPreselectedQuantity(attachment)"
                      [quantity]="getSelectedQuantity(attachment)"
                      (quantityChanged$)="updateAttachmentSelection($event, attachment)"
                      (click)="
                        selectionMode === 'single'
                          ? radioButtonForm.patchValue({
                              selectedAttachment: attachment,
                            })
                          : undefined
                      "
                    ></app-attachment-card>
                  }
                </div>
              </odx-radio-group>
            </form>
          </div>
        }
        @if (filteredOptAttachments$ | async; as optAttachments) {
          <div [hidden]="optAttachments.length < 1">
            <h6 class="odx-title-6" i18n="@@productConfiguration.optionalAttachments.header">Optionales Zubehör</h6>
            <form [formGroup]="radioButtonForm">
              <odx-radio-group formControlName="selectedAttachment" required="true" class="overflow-hidden h-100">
                <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
                  @for (attachment of optAttachments; track attachment.id) {
                    <app-attachment-card
                      [selectionMode]="selectionMode"
                      [attachmentData]="attachment"
                      [showCosts]="showCosts"
                      [preselectedQuantity]="getPreselectedQuantity(attachment)"
                      [quantity]="getSelectedQuantity(attachment)"
                      (quantityChanged$)="updateAttachmentSelection($event, attachment)"
                      (click)="
                        selectionMode === 'single'
                          ? radioButtonForm.patchValue({
                              selectedAttachment: attachment,
                            })
                          : undefined
                      "
                    ></app-attachment-card>
                  }
                </div>
              </odx-radio-group>
            </form>
          </div>
        }
        <div>
          <app-refresh-products-hint dataType="Zubehör" i18n-dataType="@@global.attachment"></app-refresh-products-hint>
        </div>
      </div>
    </odx-content-box>
  }
</div>
